import { useMutation } from "@apollo/client";
import { MT_ADD_TRIP_OPINION } from "../graphQl/ReviewAPI";

export const useAddTripOpinion = () => {
  const [addOpinionMutation, { data, loading, error }] = useMutation(MT_ADD_TRIP_OPINION);

  const addOpinion = (tripOpinionInput) => {
    return addOpinionMutation({
      variables: { tripOpinionInput },
      fetchPolicy: "network-only",
    });
  };

  const response = data?.MT_ADD_TRIP_OPINION;

  return {
    addOpinion,
    loading,
    error: response?.error || error,
    code: response?.code,
    result: response?.data,
  };
};
